/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { usePaginationState } from '@vtex/admin-ui';
import { PaginationProps } from './pagination.component';

export const usePagination = ({
  itemsPerPage,
  totalItems,
  onPageChange,
}: PaginationProps) => {
  const pagination = usePaginationState({
    pageSize: itemsPerPage,
    total: totalItems,
  });

  useEffect(() => {
    onPageChange(pagination);
  }, [pagination.range]);

  useEffect(() => {
    pagination.paginate({ type: 'reset' });
  }, [itemsPerPage]);

  return { pagination };
};
